import { render } from "./CollegeBrochureView.vue?vue&type=template&id=e472d024"
import script from "./CollegeBrochureView.vue?vue&type=script&lang=js"
export * from "./CollegeBrochureView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__